import { useState, useContext } from "react";
import { useMutation } from "@apollo/client";
import { LOGIN_USER_MUTATION } from "../../graphql/mutations/user.mutation";
import { UserContext } from "../../contexts/user.context";
import { useNavigate, useLocation } from "react-router-dom";

const DEFAULT_LOGIN_FORM = {
  email: "",
  password: "",
};

const useLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useContext(UserContext);
  const [loginForm, setLoginForm] = useState(DEFAULT_LOGIN_FORM);
  const { email, password } = loginForm;
  const [error, setError] = useState(null);
  const [login, { loading }] = useMutation(LOGIN_USER_MUTATION, {
    onError: (error) => {
      alert(error.message);
      setError(error.message);
    },
    onCompleted: (data) => {
      const { token, user } = data?.loginUser;
      if (!token || !user) return;
      localStorage.setItem("token", token);
      setUser(user);
      // If location is /login, redirect to homepage
      if (location.pathname === "/login") navigate("/parts/open");
    },
  });

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      await login({ variables: { email, password } });
    } catch (error) {
      setError(error.message);
    }
  };

  return {
    loginForm,
    setLoginForm,
    error,
    loading,
    handleLogin,
  };
};

export default useLogin;
